<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 18px">
      <el-breadcrumb-item :to="{ name: 'Apimonitor' }">监控列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{apiName}}-监控日志</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row>
      <el-button type="primary" size="mini" style="float: right;margin-left: 20px;margin-top: 5px" @click="moereDelConfirm">批量删除</el-button>
      <el-date-picker
        style="float: right"
        v-model="time"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>

    </el-row>

    <el-table :data="logData" style="width: 100%" @sort-change="sortChange"
              @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column align="center" prop="createTime" label="监控时间" sortable="custom" width="300"></el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status==0" style="color:red">故障</span>
          <span v-if="scope.row.status==1" style="color:green">正常</span>
          <!--          <img src="@/assets/greenCircle.png"/>-->
          <!--          <img src="@/assets/redCircle.png" style="width: 10px;height: 10px;margin-right: 3px"/>-->
        </template>
      </el-table-column>
      <el-table-column align="center" prop="cosTime" label="响应时间"></el-table-column>
      <el-table-column align="center" prop="log" label="日志" width="400" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column align="center" prop="respTime" label="API详情">
        <template slot-scope="scope">
          <el-button type="info" icon="el-icon-more" size="mini" @click="showLogDetail(scope.row)"></el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
    <el-dialog title="API日志详情" :visible.sync="apiLogView"
               :close-on-click-modal="false" :close-on-press-escape="false" width="70%">
      <el-table :data="logDetailList" style="width: 100%">
        <el-table-column align="center" prop="httpMethod" label="API类型"></el-table-column>
        <el-table-column align="center" prop="url" label="API地址" width="250"></el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">失败</span>
            <span v-if="scope.row.status==1">成功</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="statusCode" label="响应状态码" width="90"></el-table-column>
        <el-table-column align="center" prop="cosTime" label="响应时间"></el-table-column>
        <el-table-column align="center" prop="log" label="日志" width="300"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "ApiLog",
    data() {
      return {
        apiName: "",
        apiGuid: "",
        apiLogView: false,
        logData: [],
        sort: "desc",
        logDetailList: [],
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        logId: "",
        idList: [],
        time: ['', ''],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    methods: {
      handleSelectionChange(val) {
        this.idList = [];
        val.forEach((item) => {
          this.idList.push(item.id)
        });
      },
      moereDelConfirm() {
        this.$confirm('是否确认批量删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.idList && this.idList.length > 0) {
            //批量删除
            this.moreDelete();
          } else {
            //通过时间批量删除
            this.deleteByTime()
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteByTime() {
        let data = {
          guid: this.apiGuid,
          startTime: this.time[0],
          endTime: this.time[1],
        };
        this.$axios.post(this.apiUrl + 'apimonitor/batchDeleteMonitorLogByTime', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.currentPage=1;
              this.initLogList();
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      moreDelete() {
        let data = {
          'ids': this.idList
        };
        this.$axios.post(this.apiUrl + 'apimonitor/batchDeleteMonitorLog', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.currentPage=1;
              this.initLogList();
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.initLogList();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.initLogList();
      },
      sortChange({column, prop, order}) {
        if (order == "ascending") {
          this.sort = "asc"
        } else {
          this.sort = "desc"
        }
        this.initLogList();
      },
      showLogDetail(item) {
        this.apiLogView = true;
        this.logId = item.id;
        this.getLogDetail();
      },
      getLogDetail() {
        this.logDetailList = [];
        let url = this.apiUrl + 'apimonitor/apiLog/' + this.logId;
        this.$axios.get(url)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if (data) {
                let obj = data;
                this.logDetailList.push(obj);
              }
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initLogList() {
        let data = {
          'guid': this.apiGuid,
          'pageNo': this.currentPage,
          'pageSize': this.pageSize,
          'sort': this.sort
        };
        this.$axios.post(this.apiUrl + 'apimonitor/monitorLog', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.logData = data.list;
              this.totalElement = data.total;
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
    created() {
      this.apiName = this.$route.query.apiName;
      this.apiGuid = this.$route.query.apiGuid;
      this.initLogList();
    },

  }
</script>

<style>
  .el-tooltip__popper {
    max-width: 450px;
    background: #fcf2ff !important;
    color: #000 !important;
  }
</style>
